import React, { Dispatch, ReactElement, useEffect, useState } from 'react'
import tides from "../assets/tides.png";
import { useMapLayersContext } from '../provider/MapLayers';
import { LocationMarkerPopup } from "../mainLayer/MainWindow";

type TidesPropsType = {
    name: string;
    color?: string;
}

const Tides = (props: TidesPropsType) => {
    const { selectLayerInMap, loadLayerInMap,setIsWavesLoad } = useMapLayersContext();
    const [isSelected, setIsSelected] = useState<boolean>(false);
 

    const tidesIconClick = () => {
        if (loadLayerInMap !== "tides") {
            setIsSelected(prevState => !prevState);
            setIsWavesLoad(false);
        }
        if (isSelected===true) {
            selectLayerInMap("tidesnot");
            setIsWavesLoad(false);
          } 
    };
    useEffect(() => {
        if (isSelected) {
            selectLayerInMap("tides");
        }else{
            LocationMarkerPopup("tides");
        }
    }, [isSelected]);

    useEffect(() => {
        if (loadLayerInMap === "tides") {
            setIsSelected(true);
        }else if (loadLayerInMap !== "tides") {
            setIsSelected(false);
        }
    }, [loadLayerInMap]);

    return (
        <div className={`subItemWrapper`} onClick={(e) => tidesIconClick()} onTouchStart={(e) => tidesIconClick()}>
            {props.color && (
                <div className={`colorBox ${isSelected ? 'selected' : ''}`} style={{ backgroundColor: `${props.color}` }}></div>
            )}

            <div className={`colorBox ${isSelected ? 'selected' : ''}`}>
                <img src={tides} alt="" />
            </div>

            <span>{props.name}</span>
        </div>
    )
}

export default Tides;